// src/utils/backgrounds.ts
// Carved from the designer's file of the same path at Ventaje 991a664d (WU-141 S-6): only the light-palette key list
// ClassicLensBackground.tsx imports, byte for byte. His background catalogue and page map are not ported.
// Light palette keys used by entity card color pickers (Admin Setup, Dashboard Settings)
// All use similar lightness (~75-85% L) for consistent feel.
export const LIGHT_BACKGROUND_KEYS = [
  'icy-blue', 'soft-mint', 'soft-lavender', 'soft-peach', 'soft-sage', 'soft-sky', 'soft-rose', 'soft-sand'
] as const;
